import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { ButtonModule } from '../common/button/button.module';
import { DropdownModule } from '../common/dropdown/dropdown.module';
import { IconModule } from '../common/icon/icon.module';
import { TruncateModule } from '../common/truncate/truncate.module';
import { RtUICoreOverlayModule } from '../core/overlay/overlay.module';
import { RtUIFormsModule } from '../forms/forms.module';
import { DateRangePickerLabelPipe, getDateRangePickerLabel } from './date-range-picker-label.pipe';
import { DateRangePickerComponent, getDateRangeValueDates } from './date-range-picker.component';

@NgModule({
  imports: [
    RtUICoreOverlayModule,
    RtUIFormsModule,
    I18nModule,
    CommonModule,

    ButtonModule,
    IconModule,
    DropdownModule,
    TruncateModule,
  ],
  declarations: [DateRangePickerComponent, DateRangePickerLabelPipe],
  exports: [DateRangePickerComponent, DateRangePickerLabelPipe],
})
export class RtDateRangePickerModule {}

export {
  getDateRangeValueDates,
  getDateRangePickerLabel,
  DateRangePickerComponent,
  DateRangePickerLabelPipe,
};
